

import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import { Form, Button, ProgressBar } from 'react-bootstrap'

// service imports
import {getFormData} from "services/FormFunctions"
import { listSectionsDoc } from 'services/SectionsDocumentos';
import { ChamarGerador } from 'services/TaxasCTM24/CalcularTaxaServico/GerarDocumento';

// constant imports
import * as Styles from "constants/styles"
import { SUBTIPO, TIPO, TIPONOME } from 'constants/tiposDoc';

// function expandData(data) 
// {
//     let expandedData = {}
//     for (var key in data) 
//         {

//         if (data.hasOwnProperty(key)) {
    
//             var keyList = key.split('.');
//             expandedData = generateNewObject(keyList, keyList.length - 1, expandedData, data[key]);
//         }
    
//     }
// }

// function generateNewObject(keys, index, existingObj, value) {

//     if (index < 0) {
//         return value;
//     }

//     var lastKey = keys[index--];
//     var existingProperty = getProperty(existingObj, lastKey);

//     if (existingProperty != null && !objectsAreEqual(existingProperty, value)) {

//         var valueKey = keys[index + 2];
//         existingProperty[lastKey][valueKey] = value[valueKey];
//         value = existingProperty;


//     } else {

//         var subObj = {};
//         subObj[lastKey] = value;
//         value = subObj;
//     }

//     return generateNewObject(keys, index, existingObj, value);

// }

// function objectsAreEqual(obj1, obj2) {

//     for (var key in obj1) {

//         if (obj1.hasOwnProperty(key)) {

//             var prop = getProperty(obj2, key);
//             if (prop == null) {
//                 return false;
//             }

//         }

//     }

//     return true;

// }

// function getProperty(obj, keyDesired) {

//     for (var key in obj) {

//         if (obj.hasOwnProperty(key)) {

//             if (key === keyDesired) {

//                 return obj;

//             } else {

//                 var prop = getProperty(obj[key], keyDesired);

//                 if (prop != null) {
//                     return prop;
//                 }

//             }

//         }

//     }

//     return null;

// }

const FormButtons = ({ step, qtdSteps, handlePrevious, handleNext }) =>
{
    const proceedStyle = step < qtdSteps ? "" : "d-none"
    const enviarStyle = qtdSteps <= step ? "" : "d-none"
    return (
        <div className="d-flex justify-content-between mt-3">  
            <Button variant="primary" disabled={step === 1} onClick={handlePrevious}>Anterior</Button>
            <Button className={proceedStyle} variant="primary" disabled={step === qtdSteps} onClick={handleNext}>Próximo</Button>
            <Button className={enviarStyle} variant="success" type="submit">Enviar</Button>
        </div>
    )

}

function MultiStepForm({ tipoDoc, steps, initialData })
{

    const qtdSteps = steps.length
    const [step, setStep] = useState(1)
    const [formData, setFormData] = useState({...initialData})

    function handleNext(event) 
    {
        let form = event.currentTarget.form
        const data = getFormData(form)
        // console.log(form)
        setFormData({ ...formData, ...data })
        setStep(step + 1)
    }

    function handlePrevious(event)
    {
        let form = event.currentTarget.form
        const data = getFormData(form)
        // console.log(form)
        setFormData({ ...formData, ...data })
        setStep(step - 1)
    }

    async function handleSubmit(event)
    {
        event.preventDefault()
        const form = event.currentTarget
        const data = getFormData(form)
        const finalFormData = { ...formData, ...data }

        // TODO const formData = new FormData(form)
        // TODO const docData = Object.fromEntries(formData.entries())
        const idProc = "00.000"
        const idDoc = 1
        const tipoDoc = "AutObrasInfra"
        const subTipoDoc = undefined

        const resultMsg = await ChamarGerador(tipoDoc, subTipoDoc, finalFormData, undefined, undefined, false, finalFormData.numProc, finalFormData.anoProc, idProc, idDoc, false)
        console.log("resultMsg")
        console.log(resultMsg)
        window.scrollTo(0, 0)
    }

    useEffect(() => 
    {
        const form = document.getElementById('multi-step-form')
        const formInputs = form.getElementsByTagName('input')
        const formDropDowns = document.getElementsByTagName("select")
        const formTextAreas = document.getElementsByTagName("textArea")

        for(const inp of formInputs)
        {
            inp.value = formData.hasOwnProperty(inp.name)? formData[inp.name] : ""
            
            inp.readOnly = Object.keys(initialData).includes(inp.name) === true
            // inp.className += Object.keys(initialData).includes(inp.name) === true ? " bg-secondary opacity-75" : ""
        }
        
        for(const inp of formDropDowns) 
            inp.value = formData.hasOwnProperty(inp.name)? formData[inp.name] : ""

        for(const inp of formTextAreas) 
            inp.value = formData.hasOwnProperty(inp.name)? formData[inp.name] : ""

    }, [step]);

    
    const currentStepRendered = steps[step-1]

    return (
        <Form id='multi-step-form' className={Styles.FORM_STYLE} onSubmit={handleSubmit}>
            <h3 className="text-dark mb-3">{TIPONOME[tipoDoc]}</h3>
            <ProgressBar now={(step / qtdSteps) * 100} />
            <Form.Group controlId="formStep">
                {currentStepRendered} 
                <FormButtons step={step} qtdSteps={qtdSteps} handlePrevious={handlePrevious} handleNext={handleNext} />
            </Form.Group>
        </Form>
    )
}

// export function SwitchShow({Name, Label, Elements})
// {
//     const [show, setShow] = useState(false);
//     const [changeShow, setChangeShow] = useState(false);
//     function someoneClickedMe()
//     {
//         setChangeShow(true);
//     }
    
//     useEffect(() => {
//         if (changeShow)
//         {
//             setShow(!show);
//             setChangeShow(false)
//         }
//     }, [changeShow])

//     return (
//         <div>
//             <SwitchPadrao Name={Name} Label={Label} OnChange={someoneClickedMe}/>
//             {
//                 show ? Elements : <></>
//             }
//         </div>
        
//     )
// }

export function SwitchPadrao({Name, Label, OnChange})
{
    return <Form.Check name={Name} type="switch" label={Label} onChange={OnChange} />
}

// export function MSFormSecaoProprietario()
// {
//     let inputData = [[
//         {LabelText: "Proprietário", Name: "proprietario.nome", Placeholder: "Fulano da Silva"},
//         {LabelText: "CPF/CNPJ", Name: "proprietario.cpfCnpj", Placeholder: "111.111.111-11"}
//     ]]

//     return {LabelSecao: "Dados do Proprietário", inputData: inputData}
// }

// export function MSFormSecaoDadosImovel()
// {
//     let inputDataBak = 
//     [
//         [
//             {LabelText: "Inscrição Cadastral", Name: "dadosImovel.inscCadastral", Placeholder: "00.00.000.0000.00.000"},
//             {LabelText: "Endereço", Name: "dadosImovel.logradouro", Placeholder: "Rua A"},
//             {LabelText: "Número", Name: "dadosImovel.numPorta", Placeholder: "100"}
//         ],
//         [
//             {LabelText: "Loteamento", Name: "dadosImovel.loteamento", Placeholder: "XXXXXXX"},
//             {LabelText: "Nº Quadra", Name: "dadosImovel.numQuadra", Placeholder: "10"},
//             {LabelText: "Nº Lote", Name: "dadosImovel.numLote", Placeholder: "20"}
//         ],
//         [
//             {LabelText: "Bairro", Name: "dadosImovel.bairro", Placeholder: "Salgado Filho"},
//             {LabelText: "CEP", Name: "dadosImovel.cep", Placeholder: "00.000-000"},
//             {LabelText: "Complemento", Name: "dadosImovel.complemento", Placeholder: "Ao lado da padaria"}
//         ]
//     ]
    
//     let inputData = 
//     [
//         [
//             <TextInput Name={"dadosImovel.inscCadastral"} Placeholder={"00.00.000.0000.00.000"} Label={"Inscrição Cadastral"} />,
//             <TextInput Name={"dadosImovel.logradouro"} Placeholder={"Rua A"} Label={"Endereço"} />,
//             <TextInput Name={"dadosImovel.numPorta"} Placeholder={"100"} Label={"Número"} />
//         ],
//         [
//             <TextInput Name={"dadosImovel.loteamento"} Placeholder={"XXXXXXX"} Label={"Loteamento"} />,
//             <TextInput Name={"dadosImovel.numQuadra"} Placeholder={"10"} Label={"Nº Quadra"} />,
//             <TextInput Name={"dadosImovel.numLote"} Placeholder={"20"} Label={"Nº Lote"} />
//         ],
//         [
//             <TextInput Name={"dadosImovel.bairro"} Placeholder={"Salgado Filho"} Label={"Bairro"} />,
//             <TextInput Name={"dadosImovel.cep"} Placeholder={"00.000-000"} Label={"CEP"} />,
//             <TextInput Name={"dadosImovel.complemento"} Placeholder={"Ao lado da padaria"} Label={"Complemento"} />
//         ]
//     ]

//     return {LabelSecao: "Dados do Imóvel", inputData: inputData}
// }

// export function MSFormSecaoUsoOcupacaoDoSolo()
// {
//     let inputData = 
//     [
//         [
//             {LabelText: "Serviço", Name: "inscCadastral", Placeholder: "00.00.000.0000.00.000"},
//             {LabelText: "Classificação do Uso", Name: "logradouro", Placeholder: "Rua A"}
//         ],
//         [
//             {LabelText: "Macrozoneamento", Name: "loteamento", Placeholder: "XXXXXXX"},
//             {LabelText: "ADE/AIA", Name: "numQuadra", Placeholder: "10"}
//         ],
//         [
//             {LabelText: "Zoneamento da Aeronáutica", Name: "bairro", Placeholder: "Salgado Filho"},
//             {LabelText: "Zona de Proteção", Name: "cep", Placeholder: "00.000-000"},
//             {LabelText: "Zona de Ruído", Name: "cep", Placeholder: "00.000-000"}
//         ],
//         [
//             {LabelText: "Coeficiente de aproveitamento", Name: "bairro", Placeholder: "Salgado Filho"},
//             {LabelText: "Taxa de Permeabilidade", Name: "cep", Placeholder: "00.000-000"}
//         ],
//         [
//             {LabelText: "Usos incômodos", Name: "bairro", Placeholder: "Salgado Filho"}
//         ]
//     ]

//     return {LabelSecao: "Uso e Ocupação do Solo", inputData: inputData}
// }

export function ProcessoServicosScreen()
{
    const location = useLocation()
    const { idServ, procData, guiaData, guiaUsada, editar } = location.state

    console.log(" ----------- ProcessoServicosScreen ----------- ")
    console.log("location.state")
    console.log(idServ)
    console.log(procData)
    console.log(guiaData)
    console.log(guiaUsada)
    console.log(editar)

    const tipoDoc = guiaData?.detalhesGuia?.tipoDocDestino
    const subTipoDoc = guiaData?.detalhesGuia?.subTipoDocDestino

    // TODO aprimorar para tipoDoc inexistente, chamando função de verificar se o documento é válido com o tipo e subtipo
    if (!tipoDoc) { console.log("Erro: Entrando no formulário de gerar documento multistep sem tipoDoc") ; return }

    // TODO usar procData.numProc, procData.anoProc para autofill
    
    const steps = listSectionsDoc(tipoDoc, subTipoDoc, {obs: {}})

    // const handleSubmit = () =>
    // {
    //     // resto do submit
    // }

    return (
        <div>
            <MultiStepForm tipoDoc={tipoDoc} steps={steps} initialData={procData} />
        </div>
    )
}